import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * The bar above an `aw-table` that holds its search, inline filters and CTAs, projected left to right.
 * Filled with the table header's token so the bar and the header read as one block (FE-UI-Designs table action bar
 * standard, ported from `feature/FE-9614`). Without a side filter drawer or column chooser, there are no right-hand
 * icon buttons.
 */
@Component({
  selector: 'app-table-action-bar',
  template: `<div class="table-action-bar"><ng-content></ng-content></div>`,
  styles: `
    :host {
      display: block;
      margin-bottom: 8px;
    }
    .table-action-bar {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      gap: 16px;
      padding: 16px;
      border-radius: 4px 4px 0 0;
      background: var(--component-table-header-cell-fill);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableActionBarComponent {}
